import React, { Component } from 'react'
import styled from 'styled-components'
import { Input, Popconfirm, Button, Form, Tooltip } from 'antd'
import ReactTable from 'react-table'
import moment from 'moment'
import { filterCaseInsensitive } from '../../util'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import PropTypes from 'prop-types'

import * as scheduleRepairSelectors from '../../selectors/scheduleRepair/scheduleRepair'
import { actions as scheduleRepairActions } from '../../redux/modules/jobFunctions/scheduleRepairActions'

const FormItem = Form.Item

const AddItemsContainer = styled.div`
  padding: 10px;
  margin: 10px 0;
  border-radius: 4px;
  border: 1px solid #e2e2e2;
  background-color: #eeeeee;
`

const propTypes = {
  jobId: PropTypes.any.isRequired,

  getScheduleNotes: PropTypes.func.isRequired,
  notes: PropTypes.array,
  editScheduleNote: PropTypes.func.isRequired,
  deleteScheduleNote: PropTypes.func.isRequired
}

class Notes extends Component {
  constructor(props) {
    super(props)
    this.state = {
      attachmentDetailsVisible: false
    }

    const { getScheduleNotes, jobId } = this.props

    getScheduleNotes(jobId)
  }

  // notes things
  handleToggleNoteEditArea = () => {
    this.setState({
      noteAddEditContainer: !this.state.noteAddEditContainer
    })
  }

  createNote = params => {
    const { createScheduleNote, jobId } = this.props

    createScheduleNote({
      content: params,
      jobId: jobId
    })

    this.handleToggleNoteEditArea()
  }

  updateNote = params => {
    const { editScheduleNote, jobId } = this.props
    const { currentNoteId } = this.state

    editScheduleNote({
      content: params,
      noteId: currentNoteId,
      jobId: jobId
    })

    this.handleToggleNoteEditArea()

    this.setState({
      currentNote: null,
      currentNoteId: null
    })
  }

  deleteNote = () => {
    const { deleteScheduleNote, jobId } = this.props
    const { currentNoteId } = this.state

    deleteScheduleNote({
      noteId: currentNoteId,
      jobId: jobId
    })

    this.handleToggleNoteEditArea()

    this.setState({
      currentNote: null,
      currentNoteId: null
    })
  }

  handleRowNoteClick = row => {
    this.setState({
      noteAddEditContainer: true,
      currentNote: row,
      currentNoteId: row.id
    })
  }

  onNoteInputChange = e => {
    this.setState({
      noteContent: e.target.value
    })
  }

  handleAddEditNote = () => {
    const form = this.props.form
    const { currentNote } = this.state
    form.validateFields((err, values) => {
      if (err) {
        return
      }

      if (currentNote) {
        this.updateNote(values)
      } else {
        this.createNote(values)
      }

      form.resetFields()
    })
  }

  render() {
    const { getFieldDecorator } = this.props.form
    const { noteAddEditContainer, currentNote } = this.state
    const { notes } = this.props
    return (
      <div>
        <div className="row">
          <div className="col-md-12">
            <div className="row">
              <div className="col-md-6">
                <h4>Notes</h4>
              </div>
              <div className="col-md-6 d-flex justify-content-end">
                <Button
                  icon="plus"
                  onClick={() => this.handleToggleNoteEditArea()}
                  className="ml-2"
                >
                  {' '}
                  Add Note
                </Button>
              </div>
            </div>
            {noteAddEditContainer && (
              <AddItemsContainer>
                <Form>
                  <div className="row">
                    <div className="col-md-12">
                      <FormItem label="Content">
                        {getFieldDecorator('content', {
                          rules: [
                            {
                              required: true,
                              message: 'Content cannot be blank.'
                            }
                          ],
                          initialValue: currentNote ? currentNote.content : ''
                        })(<Input />)}
                      </FormItem>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-12 d-flex justify-content-end">
                      <Popconfirm
                        title="Are you sure you want to delete this record?"
                        onConfirm={this.deleteNote}
                        onCancel={this.cancelDelete}
                        okText="Yes"
                        cancelText="No"
                      >
                        {currentNote && <Button type="danger" icon="delete" className="mr-2" />}
                      </Popconfirm>
                      <Button onClick={() => this.handleAddEditNote()}>
                        {currentNote ? 'Edit' : 'Add'}
                      </Button>
                    </div>
                  </div>
                </Form>
              </AddItemsContainer>
            )}
            <ReactTable
              data={notes}
              getTrProps={(state, rowInfo, column, instance) => ({
                onClick: e => this.handleRowNoteClick(rowInfo.original)
              })}
              filterable
              defaultFilterMethod={filterCaseInsensitive}
              columns={[
                {
                  columns: [
                    {
                      Header: 'Content',
                      id: 'content',
                      accessor: d => <Tooltip title={d.content}>{d.content}</Tooltip>
                    },
                    {
                      Header: 'Created Date',
                      id: 'created_date',
                      accessor: d => moment.utc(d.created_date).format('M/D/YYYY'),
                      minWidth: 70
                    },
                    {
                      Header: 'Created by',
                      id: 'created_by',
                      accessor: d => `${d.created_by_first_name} ${d.created_by_last_name}`,
                      minWidth: 70
                    },
                    {
                      Header: 'Updated by',
                      id: 'updated_by',
                      accessor: d => `${d.updated_by_first_name} ${d.updated_by_last_name}`,
                      minWidth: 70
                    }
                  ]
                }
              ]}
              defaultPageSize={5}
              className="-striped -highlight"
            />
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state, props) => ({
  notes: scheduleRepairSelectors.getScheduleRepairNotes(state, props)
})
const mapDispatchToProps = (dispatch, props) => ({
  getScheduleNotes: jobId => dispatch(scheduleRepairActions.getScheduleNote(jobId)),
  editScheduleNote: ({ content, noteId, jobId }) =>
    dispatch(scheduleRepairActions.editScheduleNote({ content, noteId, jobId })),
  deleteScheduleNote: ({ noteId, jobId }) =>
    dispatch(scheduleRepairActions.deleteScheduleNote({ noteId, jobId })),
  createScheduleNote: ({ content, jobId }) =>
    dispatch(scheduleRepairActions.createScheduleNote({ content, jobId }))
})

Notes.propTypes = propTypes
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Form.create()(Notes)))



// WEBPACK FOOTER //
// ./src/components/scheduleRepair/Notes.js